@if (loadedError) {
    <app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
}
@if (!loadedError && loaded && !data) {
    <app-widgets-overlay type="no-match"></app-widgets-overlay>
}
@if (loaded) {
    <div class="widget-container d-flex flex-column">
        <div class="widget-container__object">
            @if (!noTitle) {
                <h1 class="widget-title align-self-center">
                    {{ 'web.widget_both_team_to_score_last_matches' | translate }}
                </h1>
            }
            <div class="d-flex">
                @if (data?.home; as p) {
                    <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
                        <div class="widget-team__name d-flex align-items-center">
                            <img
                                (error)="imageError($event)"
                                [attr.src]="p.image | responsive: 'participant' : 'medium'"
                                [alt]="p.name"
                                class="img-fluid app-cursor mr-1"
                            />
                            <div>{{ p.name }}</div>
                        </div>
                    </div>
                }
                @if (data?.away; as p) {
                    <div class="widget-team mt-1 d-flex flex-column widget-team--second" data-cy="team">
                        <div class="widget-team__name d-flex align-items-center justify-content-end">
                            <div>{{ p.name }}</div>
                            <img
                                (error)="imageError($event)"
                                [attr.src]="p.image | responsive: 'participant' : 'medium'"
                                [alt]="p.name"
                                class="img-fluid app-cursor ml-1"
                            />
                        </div>
                    </div>
                }
            </div>
            <!-- Clean sheet-->
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome">
                        &nbsp;
                    </div>
                    <div class="widget-form-participant-text font-weight-bold font-1-1x">
                        @if (!isHockey) {
                            {{ 'web.widget_clean_sheet_prct' | translate }}
                        }
                        @if (isHockey) {
                            {{ 'web.widget_clean_sheet_hockey_prct' | translate }}
                        }
                    </div>
                    <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway">
                        &nbsp;
                    </div>
                </div>
                <div class="d-flex justify-content-around">
                    <app-chart-circle-somple [percentage]="+cleanHome()" [text]="data?.home?.name" data-cy="streakHome">
                        {{ cleanHome() }}%
                    </app-chart-circle-somple>
                    <app-chart-circle-somple [percentage]="+cleanAway()" [text]="data?.away?.name" data-cy="streakAway">
                        {{ cleanAway() }}%
                    </app-chart-circle-somple>
                </div>
            </div>
            <!-- Score sheet-->
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <div class="widget-form-participant widget-form-participant--home" data-cy="cornersHome">
                        &nbsp;
                    </div>
                    <div class="widget-form-participant-text font-weight-bold font-1-1x">
                        {{ 'web.widget_goal_scored_prct' | translate }}
                    </div>
                    <div class="widget-form-participant widget-form-participant--away" data-cy="cornersAway">
                        &nbsp;
                    </div>
                </div>
                <div class="d-flex justify-content-around">
                    <app-chart-circle-somple [percentage]="scoredHome()" [text]="data?.home?.name" data-cy="scoreHome">
                        {{ scoredHome() }}%
                    </app-chart-circle-somple>
                    <app-chart-circle-somple [percentage]="scoredAway()" [text]="data?.away?.name" data-cy="scoreAway">
                        {{ scoredAway() }}%
                    </app-chart-circle-somple>
                </div>
            </div>
            <!-- Periods-->
            @if (isHockey) {
                <div class="mt-5">
                    @for (period of periods; track $index) {
                        <div class="d-flex widget-form-participant-container">
                            <div class="flex-fill">
                                <h2 class="text-center widget-form-participant-container-h2 --ext">
                                    {{ 'status.ice-hockey.period_' + period | translate }}
                                </h2>
                                <div class="d-flex">
                                    <div
                                        class="widget-form-participant-bar widget-form-participant-bar--home"
                                        [style.width.%]="width('homeWidth', period)"
                                    >
                                        {{ clean('home', period) }}%
                                    </div>
                                    <div
                                        class="widget-form-participant-bar widget-form-participant-bar--away"
                                        [style.width.%]="width('awayWidth', period)"
                                    >
                                        {{ clean('away', period) }}%
                                    </div>
                                </div>
                                <div class="widget-form-participant-text text-center">
                                    {{ 'web.widget_clean_sheet_hockey_prct' | translate }}
                                </div>
                                <div class="d-flex">
                                    <div
                                        class="widget-form-participant-bar widget-form-participant-bar--home"
                                        [style.width.%]="width('homeWidth2', period)"
                                    >
                                        {{ scored('home', period) }}%
                                    </div>
                                    <div
                                        class="widget-form-participant-bar widget-form-participant-bar--away"
                                        [style.width.%]="width('awayWidth2', period)"
                                    >
                                        {{ scored('away', period) }}%
                                    </div>
                                </div>
                                <div class="widget-form-participant-text text-center">
                                    {{ 'web.widget_goal_scored_prct' | translate }}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
            <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
                {{ 'web.num_of_matches' | translate }} ({{ num }})
            </div>
            <div class="widget-logo d-flex justify-content-center mt-4">
                <img
                    [src]="'/img/' + client.getName() + '.png'"
                    [alt]="client.getName()"
                    data-cy="logo"
                    class="widget-logo-client"
                />
            </div>
        </div>
    </div>
}
